import React from 'react';

export default function Lock({ fill = '#000' }) {
  return (
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" cursor="pointer">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 4.583C3.5 2.062 5.505 0 8 0c2.496 0 4.5 2.062 4.5 4.583V7h1a.5.5 0 01.5.5v8a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5h1V4.583zm8 0V7h-7V4.583C4.5 2.595 6.077 1 8 1c1.924 0 3.5 1.594 3.5 3.583zM8 10a1 1 0 00-.5 1.866V13.5a.5.5 0 001 0v-1.634A1 1 0 008 10z"
        fill={fill}
      />
    </svg>
  );
}
